import { Button, Input, Modal } from '@scuf/common';
import useFetch from 'helpers/hooks/useFetch';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { REPAIR_CENTER } from 'resources';
import LabelDescription from './labelDescription';
import { formatDate, handleYesOrNo } from 'helpers';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { notificationAtom } from 'resources';
import { MicrosigaSerialNumber } from 'models/repaircenter/rmaModel';
import i18n from 'i18n';

export const WarrantyConsultModal: React.FC = () => {
    const [serial, setSerialNumber] = useState<string>("");
    const { t } = useTranslation(['common', 'repaircenter']);
    const setNotification = useSetRecoilState(notificationAtom);
    const [microsigaItem, consultSerial, loading] = useFetch<string, MicrosigaSerialNumber>({
        url: REPAIR_CENTER.consultSerialNumber,
        method: 'POST',
        onError: 'LoadInfo'
    });
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const handleClick = async () => {
        await consultSerial(JSON.stringify(serial!), current => {
            if (current.message === 'True') {
                setNotification(old => ({ ...old, message: 'Conflito de dados', type: 'information' }));
                return;
            }
            if (current.data === null) {
                setNotification(old => ({ ...old, message: 'NoData', type: 'information' }));
            } else {
                setIsModalOpen(!!current.data);
            }
            return;
        });
    };

    function formatDateDescritivo(dateInput: string | undefined, locale: string = 'pt-BR'): string {
        if (!dateInput) return '';

        const date = new Date(dateInput);
        if (isNaN(date.getTime())) return '';

        const dia = date.getDate();
        const mes = date.toLocaleString(locale, { month: 'long' });
        const ano = date.getFullYear();

        const mesFormatado = mes.charAt(0).toUpperCase() + mes.slice(1);

        let connector1 = '';
        let connector2 = '';

        switch (locale) {
            case 'en':
            case 'en-US':
                connector1 = 'of';
                connector2 = '';
                break;
            default:
                connector1 = 'de';
                connector2 = 'de';
        }

        return `${dia} ${connector1} ${mesFormatado} ${connector2} ${ano}`.trim();
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
            <Modal className="no-padding" size="large" open={isModalOpen} closeIcon={true} onClose={() => setIsModalOpen(false)}>
                <div className="modalConsultWaranty">
                    <Modal.Header>
                        <div className="modalHeader">
                            <h2> {t('translation.About')} </h2>
                        </div>
                    </Modal.Header>
                    <div className="grid-view" style={{ margin: '12px' }}>
                        <LabelDescription title={t('translation.SerialNumber')} value={microsigaItem?.data?.serialNumber} />
                        <LabelDescription title={t('translation.PartNumber')} value={microsigaItem?.data?.partNumber} />
                        <LabelDescription title={t('translation.Description')} value={microsigaItem?.data?.description} />
                        <LabelDescription
                            title={t('repaircenter:translation.MaintenanceContractValidity')}
                            value={formatDateDescritivo(microsigaItem?.data?.contractValidity, i18n.language)}
                        />
                        <LabelDescription
                            title={t('repaircenter:translation.FactoryWarrantyValidity')}
                            value={formatDateDescritivo(microsigaItem?.data?.msdFactoryWarranty, i18n.language)}
                        />
                        <LabelDescription
                            title={t('repaircenter:translation.ServiceWarrantyValidity')}
                            value={formatDateDescritivo(microsigaItem?.data?.serviceWarranty, i18n.language)}
                        />
                        <LabelDescription
                            title={t('translation.MaintenanceContract')}
                            value={handleYesOrNo(microsigaItem?.data?.flagHasContract)}
                        />
                        <LabelDescription
                            title={t('translation.FactoryWarranty')}
                            value={handleYesOrNo(microsigaItem?.data?.flagHasFactoryWarranty)}
                        />
                        <LabelDescription
                            title={t('translation.ServiceWarranty')}
                            value={handleYesOrNo(microsigaItem?.data?.flagHasServiceWarranty)}
                        />
                    </div>
                </div>
            </Modal>
            <Input
                placeholder={t('common:services.WarrantyConsult')}
                value={serial}
                onChange={sn => setSerialNumber(sn)}
            ></Input>
            <Button content={t('common:actions.Search')} loading={loading} onClick={handleClick} disabled={!serial} />
        </div>
    );
};
